import type { FC } from "react"

import ConfirmationDialog from "@/components/common/Modals/ConfirmationDialog"

interface LotRemovalConfirmationDialogProps {
  onClose: () => void
  onConfirm: () => void
}

export const LotRemovalConfirmationDialog: FC<LotRemovalConfirmationDialogProps> = ({ onClose, onConfirm }) => (
  <ConfirmationDialog
    title='Remove Lot'
    content='Are you sure you want to remove this lot? '
    closeLabel='Cancel'
    confirmLabel='Remove'
    isWarning
    onClose={onClose}
    onConfirm={onConfirm}
  />
)
